let DEBUG = true;
let HOST_URL = 'https://justdjango-chat.herokuapp.com';
let SOCKET_URL = 'wss://justdjango-chat.herokuapp.com';
if (DEBUG) {
  HOST_URL = process.env.REACT_APP_API_URL || 'http://51.210.77.249:8000/';
  SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'ws://51.210.77.249:8000';
}

export {HOST_URL, SOCKET_URL};
